import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/logo.png";
import { useLocation } from "react-router-dom";
import { toWords } from "number-to-words"; // Import the library
import { stringify } from "uuid";
import { saveOrUpdateInvoiceData } from "../../api/PupilApi";
import autoTable from "jspdf-autotable";
import kiwi from "../../assets/kiwi.jpeg";
import mercely from "../../assets/mercely.jpeg";
import toast, { Toaster } from "react-hot-toast";
const InvoicePopup = ({ onClose, selectedItems, orgData }) => {
  const location = useLocation();
  const currentDate = new Date();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
  const year = currentDate.getFullYear();

  // const selectedItems = location.state?.selectedItems || [];

  const generateInvoiceNumber = () => {
    const now = new Date();
    const timestamp =
      now.getFullYear().toString().slice(-2) +
      (now.getMonth() + 1).toString().padStart(2, "0") +
      now.getDate().toString().padStart(2, "0") +
      now.getHours().toString().padStart(1, "0") +
      now.getMinutes().toString().padStart(1, "0") +
      now.getSeconds().toString().padStart(2, "0");
    return timestamp;
  };

  const [invoiceData, setInvoiceData] = useState(
    selectedItems.map((item) => {
      // Validate required properties
      if (!item.dealerPrice || !item.sellingPrice || !item.quantity || !item._id) {
        console.error("Missing required properties in item:", item);
        return null; // Skip invalid items
      }

      const pricePerUnit = parseFloat(item.dealerPrice) || 0;
      const priceWithoutGST = (pricePerUnit * 100) / ((item?.gstPercentage || 0) + 100);
      const gstAmount = pricePerUnit - priceWithoutGST;

      // Extract quantity from product name if format is like "[30ML, 20NOS]"
      // let quantityInPack = 1;

      // if (item.productname && item.productname.includes("[")) {
      //   const match = item.productname.match(/\[(.*?)\]/);
      //   console.log("matches"+match)
      //   if (match) {
      //     const parts = match[1].split(',');
      //     for (let part of parts) {
      //       const trimmed = part.trim();
      //       const qtyMatch = trimmed.match(/(\d+)\s*nos/i);
      //       console.log("qtymatch"+JSON.stringify(qtyMatch));
      //       if (qtyMatch) {
      //         quantityInPack = parseInt(qtyMatch[1], 10);
      //         console.log("quantityInpack"+JSON.stringify(quantityInPack));
      //         break;
      //       }
      //     }
      //   }
      // }
      const extractMrpQuantityFromName = (productName) => {
        const match = productName.match(/(\d+)\s*Nos/i);
        return match ? parseInt(match[1], 10) : 1; // default to 1 if not found
      };
      const quantityInPack = extractMrpQuantityFromName(item.productName);
      console.log(quantityInPack);

      const invoiceItem = {
        ...item,
        itemId: item._id,
        quantity: item.quantity,
        unit: "pcs",
        mrp: parseFloat(item.sellingPrice) || 0,
        pricePerUnit: priceWithoutGST.toFixed(2),
        gstAmountPerUnit: gstAmount.toFixed(2),
        discount: 0,
        shippingAddress: item?.hippingAddress,
        gst: gstAmount.toFixed(2),
        gstPercentage: item.gstPercentage || 0,
        amount: parseFloat(item.quantity * pricePerUnit) || 0,
        date: new Date().toLocaleDateString(),
        mrpPricePerUnit: parseFloat((item.quantity * pricePerUnit) / quantityInPack).toFixed(2),
        quantityInPack: (parseFloat(item.sellingPrice) || 0)/quantityInPack,
      };

      // Log the item for validation
      console.log("Processed Invoice Item:", invoiceItem);

      return invoiceItem;
    }).filter(Boolean) // Filter out any null values from invalid items
  );



  // Log the final invoiceData
  console.log("Final Invoice Data:", invoiceData);
  const [lineManagerEmail, setLineManagerEmail] = useState("");
  const [shopEmail, setShopEmail] = useState("");
  const [shopContactNo, setShopContactNo] = useState("");
  const [shopState, setShopState] = useState("");
  const [shopGst, setShopGst] = useState("");
  const [shopName, setShopName] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [booleanFlag, setBooleanFlag] = useState(true);
  const [logoCategory, setLogoCategory] = useState("kiwi");
  const [invoiceItemData, setInvoiceItemData] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = (today.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single digits
    const dd = today.getDate().toString().padStart(2, "0"); // Add leading zero for single digits
    return `${yyyy}-${mm}-${dd}`; // Return date in 'yyyy-mm-dd' format
  });

  const [shippingAddress, setShippingAddress] = useState("");
  const [received, setReceived] = useState(0);
  const [invoiceNo, setInvoiceNo] = useState(orgData.invoiceNumber);

  const handleInputChange = (index, field, value) => {
    if (field === "quantity" && (isNaN(value) || value < 0)) {
      toast.error("Quantity must be a positive number");
      return; // Prevents updating state with an invalid value
    }

    setBooleanFlag(true);
    const updatedItems = [...invoiceData];

    // Allow typing decimals properly (don't convert to number immediately)
    if (field === "pricePerUnit") {
      // Prevent invalid characters and allow only numbers with decimals
      const regex = /^[0-9]*\.?[0-9]*$/;
      if (!regex.test(value)) return; // Stops invalid input

      updatedItems[index][field] = value; // Keep as string while typing
    } else {
      updatedItems[index][field] = ["quantity", "discount", "gst", "gstPercentage"].includes(field)
        ? parseFloat(value) || 0
        : value;
    }

    // Convert pricePerUnit to float only when needed for calculations
    const pricePerUnit = parseFloat(updatedItems[index].pricePerUnit) || 0;
    const { quantity, discount, gstPercentage } = updatedItems[index];

    // Calculate price after discount
    const discountedPrice = pricePerUnit - (pricePerUnit * discount) / 100;
    const subtotal = quantity * discountedPrice;

    // Apply GST
    const gstAmount = (subtotal * gstPercentage) / 100;

    // Store calculated values
    updatedItems[index].gstAmount = parseFloat(gstAmount.toFixed(2));
    updatedItems[index].gst = gstAmount.toFixed(2);
    updatedItems[index].amount = parseFloat((subtotal + gstAmount).toFixed(2));

    setInvoiceData(updatedItems);
  };




  const totalAmount = invoiceData.reduce((acc, item) => acc + item.amount, 0);
  const roundedOffTotal = Math.round(totalAmount);
  const balance = received - roundedOffTotal;
  const validateUpdateInvoiceData = (invoiceData) => {
    // Filter out items with quantity 0
    const filteredInvoiceData = invoiceData.filter((item) => item.quantity > 0);

    return filteredInvoiceData;
    // Return the filtered data
    //
  };
  const generateInvoicePDF = (invoiceDataItem) => {

    const doc = new jsPDF();
    // Constants for layout
    const margin = 8; // Reduced margin
    const pageWidth = doc.internal.pageSize.width;
    const centerX = pageWidth / 2;
    const formatDate = (inputDate) => {
      if (!inputDate) return "N/A";

      const [month, day, year] = inputDate.split('/');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      return `${day}-${monthNames[parseInt(month, 10) - 1]}-${year}`;
    };

    const formattedDate = formatDate(invoiceData[0]?.date);

    if (logoCategory === "kiwi") {
      // Add Logo
      doc.addImage(kiwi, "PNG", margin, margin, 15, 10); // Reduced logo size
    }
    else {
      // Add Logo
      doc.addImage(mercely, "PNG", margin, margin, 15, 10); // Reduced logo size
    }
    // Business Name (Centered)
    doc.setFont("helvetica", "bold").setFontSize(14); // Reduced font size
    doc.text("Hare Krishna Traders".toUpperCase(), centerX, 13, { align: "center" }); // Adjusted Y position

    // Address Details
    const addressLines = [
      "12/22, Koothanur, Mallikundam Road, Mecheri, Salem 636458",
      "Phone: 9787292119, 9789573268, 9790168814 | Email: jayaprakash892@gmail.com",
      "GSTIN: 33CFYPM6838M1ZF | State: TamilNadu (33)"
    ];

    let addressY = 20; // Adjusted Y position
    addressLines.forEach(line => {
      doc.setFont("helvetica", "normal").setFontSize(8); // Reduced font size
      doc.text(line, centerX, addressY, { align: "center" });
      addressY += 5; // Reduced spacing
    });

    // Horizontal Line
    doc.setDrawColor(150);
    doc.line(margin, addressY + 1, pageWidth - margin, addressY + 1); // Adjusted Y position

    // **TAX INVOICE Title**
    doc.setFontSize(12).setTextColor(0, 0, 128).setFont("helvetica", "bold"); // Reduced font size
    doc.text("TAX INVOICE", centerX, addressY + 5, { align: "center" }); // Adjusted Y position

    // **Invoice Details (Right Side)**
    doc.setFontSize(9).setTextColor(0, 102, 51); // Reduced font size
    doc.text("Invoice Details:", 130, addressY + 10); // Adjusted X and Y positions
    doc.setFontSize(8).setTextColor(0); // Reduced font size
    doc.text(`Invoice No: ${orgData.invoiceNumber || "N/A"}`, 130, addressY + 15); // Adjusted Y position
    doc.text(`Date: ${formattedDate}`, 130, addressY + 20);
    doc.text(`Place of Supply: TamilNadu (33)`, 130, addressY + 25); // Adjusted Y position

    // **Billing & Shipping Headers (Green Color)**
    doc.setFontSize(9).setTextColor(0, 102, 51); // Reduced font size
    doc.text("Bill To:", margin, addressY + 10); // Adjusted Y position

    doc.setFontSize(8).setTextColor(0); // Reduced font size
    doc.setFont("helvetica", "bold").setFontSize(9).text(`${shopName.toLocaleUpperCase() || "N/A"}`, margin, addressY + 15); // Adjusted Y position
    doc.setFontSize(8).text(`${billingAddress || "N/A"}`, margin, addressY + 21); // Adjusted Y position
    doc.setFontSize(8).text(`Contact No: ${shopContactNo || "N/A"}`, margin, addressY + 25); // Adjusted Y position
    doc.setFontSize(8).text(`GSTIN Number: ${shopGst || "N/A"}`, margin, addressY + 29); // Adjusted Y position
    doc.setFontSize(8).text(`State: ${shopState || "N/A"}`, margin, addressY + 33); // Adjusted Y position
    // Calculate Totals
    const totals = invoiceData.reduce(
      (acc, item) => {
        acc.totalQuantity += item.quantity;
        acc.totalDiscount += item.discount;
        acc.totalGST += item.gst * 1;
        acc.price += item.pricePerUnit * item.quantity;
        acc.totalAmount += item.amount;
        return acc;
      },
      { totalQuantity: 0, totalDiscount: 0, totalGST: 0, totalAmount: 0, price: 0 }
    );
    // Determine the number of products in the invoice
    const productCount = invoiceData.length;

    // Adjust cellPadding based on the number of products
    const dynamicCellPadding = productCount > 25 ? 1 : 1.5;
    const fontsizeadjust = productCount > 25 ? 7 : 8;

    doc.autoTable({
      head: [
        [
          "S.NO",
          "Product Name",
          "Single/Unit",
          "MRP",
          "Qty",
          "Unit",
          "Price/Unit",
          "GST/Unit",
          "Discount",
          "Price",
          "GST",
          "Amount",
        ],
      ],
      body: [
        ...invoiceDataItem.map((item, index) => [
          { content: index + 1, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: item.productName.toUpperCase(), styles: { fontStyle: "bold", textColor: [0, 0, 0] } },
          { content: ` ${item?.quantityInPack}`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: ` ${item.sellingPrice}`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: item.quantity, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: item.unit, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: ` ${item.pricePerUnit}`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: `${((item.gst)/(item.quantity)).toFixed(2)}(${item.gstPercentage}%)`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: `${item.discount}%`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: ` ${(item.pricePerUnit * item.quantity).toFixed(2)}`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: ` ${(item.gst * 1).toFixed(2)}`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
          { content: ` ${item.amount.toFixed(2)}`, styles: { fontStyle: "medium", textColor: [0, 0, 0] } },
        ]),
        // **Total Row**
        [
          { content: "TOTAL", styles: { fontStyle: "bold", fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: totals.totalQuantity, styles: { fontStyle: "bold", fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: "", styles: { fillColor: [255, 204, 0] } },
          { content: ` ${totals.price.toFixed(2)}`, styles: { fontStyle: "bold", fillColor: [255, 204, 0] } },
          { content: ` ${totals.totalGST.toFixed(2)}`, styles: { fontStyle: "bold", fillColor: [255, 204, 0] } },
          { content: ` ${totals.totalAmount.toFixed(2)}`, styles: { fontStyle: "bold", fillColor: [255, 204, 0] } },
        ],
      ],
      startY: addressY + 35,
      theme: "grid",
      styles: {
        fontSize: fontsizeadjust, cellPadding: dynamicCellPadding, fontStyle: "bold", tableLineColor: [0, 0, 0], // **Black Table Border**
        tableLineWidth: 1
      }, // **Dynamic cellPadding**
      headStyles: {
        fillColor: [0, 102, 51],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        tableLineColor: [0, 0, 0],
      },
      margin: 8,
      pageBreak: "auto"
    });

    // **Final Summary Table**
    let finalY = doc.lastAutoTable.finalY + 0;

    const summaryData = [
      ["Subtotal Price", ` ${totals.price.toFixed(2)}`],
      ["SGST @9%", ` ${(totals.totalGST / 2).toFixed(2)}`],
      ["CGST @9%", ` ${(totals.totalGST / 2).toFixed(2)}`],
      ["Rounded Off Total", ` ${Math.round(totals.totalAmount).toFixed(2)}`],
    ];

    // Add the TOTAL row with highlighting
    summaryData.push([
      { content: "TOTAL", styles: { fontStyle: "bold", fillColor: [255, 204, 0], halign: "center" } },
      { content: ` ${totals.totalAmount.toFixed(2)}`, styles: { fontStyle: "bold", fillColor: [255, 204, 0], halign: "right" } },
    ]);

    doc.autoTable({
      startY: finalY,
      head: [["Description", "Amount"]],
      body: summaryData,
      theme: "grid",
      styles: { fontSize: fontsizeadjust, cellPadding: dynamicCellPadding, textColor: [0, 0, 0], fontStyle: "bold", }, // **Dynamic cellPadding applied**
      headStyles: {
        fillColor: [0, 102, 51],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellWidth: 30, halign: "left" },
        1: { cellWidth: 25, halign: "right" },
      },
      margin: { left: 147 },
      tableWidth: 35,
    });


    // **Total Amount in Words**
    let totalAmountWords = toWords(Math.round(totals.totalAmount)).toLowerCase() + " only";
    doc.setFontSize(9).setTextColor(0, 0, 0);
    doc.text("Invoice Amount In Words:", margin, doc.lastAutoTable.finalY - 28);
    doc.setFontSize(9).setTextColor(0, 102, 51);
    doc.text(totalAmountWords, margin, doc.lastAutoTable.finalY - 22);
    doc.setFontSize(9).setTextColor(0, 0, 0);
    doc.text("Terms and Conditions", margin, doc.lastAutoTable.finalY - 16);
    doc.setFontSize(9).setTextColor(127, 0, 255);
    doc.text("Thanks for doing businees with us", margin, doc.lastAutoTable.finalY - 8);

    if (shippingAddress) {
      doc.setFontSize(10).setTextColor(0, 102, 51);
      doc.text("Shipping Address", margin, doc.lastAutoTable.finalY - 0);
      doc.setFontSize(9).setTextColor(0, 0, 0);
      doc.text(shippingAddress, margin, doc.lastAutoTable.finalY + 8);
    }

    // **Final Notes & Footer**
    let footerY = doc.lastAutoTable.finalY + 8; // Adjust Y position after the table


    // Left Side: "For: HARE KRISHNA TRADERS"
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("For: HARE KRISHNA TRADERS", 150, footerY);

    // Right Side: "Authorized Signatory"
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Authorized Signatory", pageWidth - 15, footerY + 20, { align: "right" });

    // Signature Line (Text Input Field Simulation)
    doc.setLineWidth(0.5);
    doc.line(pageWidth - 60, footerY + 13, pageWidth - 13, footerY + 13); // Draws a signature line

    // **Download the PDF**
    doc.save(`Invoice_${orgData.invoiceNumber || "N/A"}.pdf`);



  };
  const validateInvoiceData = () => {
    let isValid = true;

    for (const invoiceItem of invoiceData) {
      for (const selectedItem of selectedItems) {
        if (selectedItem._id === invoiceItem._id) {
          console.log(
            `Checking ${invoiceItem.productName}: Invoice Quantity = ${invoiceItem.quantity}, Stock = ${selectedItem.quantity}`
          );

          if (invoiceItem.quantity > selectedItem.quantity) {
            toast.error(
              `Quantity of ${invoiceItem.productName} cannot exceed available stock of ${selectedItem.quantity}`
            );
            isValid = false;
            break; // Exit inner loop as we already found an issue
          }
        }
      }
    }

    setBooleanFlag(isValid);
    return isValid;
  };




  const handleSaveInvoice = async () => {
    // alert("Boolean flag"+JSON.stringify(booleanFlag));
    // if (validateInvoiceData()) {
    const invoiceDataItem = validateUpdateInvoiceData(invoiceData);
    console.log(invoiceDataItem);
    setInvoiceNo(orgData.invoiceNumber);
    try {

      const invoicePayload = {
        invoiceNo: orgData.invoiceNumber,
        date: invoiceDate,
        lineManagerEmail,
        shopName,
        billingAddress,
        shopContactNo,
        shopEmail,
        orgEmail: `orgData${month}${year}@yaazhtech.com`, // Dynamic email,
        shopState,
        shopGst,
        received,
        items: invoiceDataItem,
        totalAmount: roundedOffTotal,
        balance,
        logoCategory,
        
      };

      const response = await saveOrUpdateInvoiceData(invoicePayload);

      //  alert(response.data.success)
      if (response.data.success) {
        // alert("Invoice saved successfully!");
        generateInvoicePDF(invoiceDataItem);
        //onClose();
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
        // alert("Failed to save invoice."+response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error saving invoice:", error);
      // alert("An error occurred while saving the invoice.");
    }
  }

  // Handle line manager email change
  const handleLineManagerEmailChange = (e) => {
    const selectedEmail = e.target.value;
    setLineManagerEmail(selectedEmail);
    // You can use the selected email for any logic you'd like to apply for the line manager
  };

  // Handle shop email change
  const handleShopEmailChange = (e) => {
    const selectedShopEmail = e.target.value;
    setShopEmail(selectedShopEmail);

    // Find the selected shop from the shopClientDataList based on the selected shopEmail
    const selectedShop = orgData.shopClientDataList.find(
      (shop) => shop.shopEmail === selectedShopEmail
    );

    if (selectedShop) {
      setShopName(selectedShop.shopName);
      setShopContactNo(selectedShop.shopContactNo);
      setShopState(selectedShop.shopState);
      setShopGst(selectedShop.shopGst);
      setBillingAddress(selectedShop.billingAddress);
    }
  };
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center overflow-auto">
      <div className="bg-white p-4 rounded-md w-3/4">
        <h3 className="text-lg font-bold mb-3">Invoice Details</h3>

        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="text-xs font-medium">Invoice Date</label>
            <input
              type="date"
              value={invoiceDate}
              onChange={(e) => setInvoiceDate(e.target.value)}
              className="w-full border p-1 text-sm"
            />
          </div>
          {/* Line Manager Selection */}
          <div>
            <label className="text-xs font-medium">Line Manager Email</label>
            <select
              value={lineManagerEmail}
              onChange={handleLineManagerEmailChange}
              className="w-full border p-1 text-sm"
            >
              <option value="">Select Line Manager</option>
              {orgData.lineManagerDataList.map((lineManager, index) => (
                <option key={index} value={lineManager.lineManagerEmail}>
                  {lineManager.lineManagerEmail}
                </option>
              ))}
            </select>
          </div>

          {/* Shop Email Selection */}
          <div>
            <label className="text-xs font-medium">Shop Email</label>
            <select
              value={shopEmail}
              onChange={handleShopEmailChange}
              className="w-full border p-1 text-sm"
            >
              <option value="">Select Shop</option>
              {orgData.shopClientDataList.map((shop, index) => (
                <option key={index} value={shop.shopEmail}>
                  {shop.shopEmail}
                </option>
              ))}
            </select>
          </div>

          {/* Shop Details */}
          <div>
            <label className="text-xs font-medium">Shop Name</label>
            <input
              type="text"
              value={shopName}
              onChange={(e) => setShopName(e.target.value)}
              className="w-full border p-1 text-sm"
            />
          </div>

          <div>
            <label className="text-xs font-medium">Shop Contact No</label>
            <input
              type="text"
              value={shopContactNo}
              onChange={(e) => setShopContactNo(e.target.value)}
              className="w-full border p-1 text-sm"
            />
          </div>

          <div>
            <label className="text-xs font-medium">Shop State</label>
            <input
              type="text"
              value={shopState}
              onChange={(e) => setShopState(e.target.value)}
              className="w-full border p-1 text-sm"
            />
          </div>

          <div>
            <label className="text-xs font-medium">Shop GST</label>
            <input
              type="text"
              value={shopGst}
              onChange={(e) => setShopGst(e.target.value)}
              className="w-full border p-1 text-sm"
            />
          </div>

          <div className="grid grid-cols-2 gap-2 mt-2">
            <div>
              <label className="text-xs font-medium">Billing Address</label>
              <textarea
                value={billingAddress}
                onChange={(e) => setBillingAddress(e.target.value)}
                className="w-full border p-1 text-sm h-12"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div>
              <label className="text-xs font-medium">Shipping Address</label>
              <textarea
                value={shippingAddress}
                onChange={(e) => setShippingAddress(e.target.value)}
                className="w-full border p-1 text-sm h-12"
              />`
            </div>
          </div>

        </div>

        {/* Select company logo */}
        <div>
          <label className="text-xs font-medium">Select Company Logo</label>
          <select
            value={logoCategory}
            onChange={(e) => setLogoCategory(e.target.value)}
            className="w-full border p-1 text-sm"
          >
            <option value="mercely">Mercely</option>
            <option value="kiwi">Kiwi</option>
          </select>
        </div>

        <table className="w-full bg-white border border-gray-300 text-xs mt-2">
          <thead>
            <tr className="bg-gray-200 text-xs">
              <th>Product</th>
              <th>Single per unit</th>
              <th>MRP</th>
              <th>Qty</th>
              <th>Unit</th>
              <th>Price/Unit</th>
              <th>Discount</th>
              <th>GSTPercentage</th>
              <th>GST Amount</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData.map((item, index) => (
              <tr key={index} className="border-b border-gray-300">
                <td>{item.productName}</td>
                <td>{item.quantityInPack}</td>
                <td>{item.mrp}</td>
                <td>
                  <input
                    type="text"
                    value={item.quantity}
                    onChange={(e) =>
                      handleInputChange(index, "quantity", e.target.value)
                    }
                    className="w-full border px-1 text-xs"
                  />
                </td>
                <td>
                  <select
                    value={item.unit}
                    onChange={(e) =>
                      handleInputChange(index, "unit", e.target.value)
                    }
                    className="w-full border px-1 text-xs"
                  >
                    <option value="pcs">pcs</option>
                    <option value="kg">kg</option>
                    <option value="liters">liters</option>
                    <option value="meters">meters</option>
                    <option value="dozen">dozen</option>
                    <option value="box">box</option>
                    <option value="bag">bag</option>
                    <option value="pac">pac</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    value={item.pricePerUnit}
                    onChange={(e) =>
                      handleInputChange(index, "pricePerUnit", e.target.value)
                    }
                    placeholder="Enter Price/Unit"
                    className="w-full border px-1 text-xs"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={item.discount}
                    onChange={(e) =>
                      handleInputChange(index, "discount", e.target.value)
                    }
                    placeholder="Enter discount in %"
                    className="w-full border px-1 text-xs"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={item.gstPercentage}
                    onChange={(e) =>
                      handleInputChange(index, "gstPercentage", e.target.value)
                    }
                    className="w-full border px-1 text-xs"
                  />
                </td>
                <td>{item.gst}</td>
                <td>Rs. {item.amount.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>


        <div className="flex justify-between mt-2 text-sm">
          <h4>Total Amount: {totalAmount}</h4>
          <div>
            <button
              onClick={handleSaveInvoice}
              className="bg-blue-500 text-white px-3 py-1 rounded text-xs"
            >
              Download Invoice
            </button>
            <button
              onClick={onClose}
              className="ml-2 bg-gray-500 text-white px-3 py-1 rounded text-xs"
            >
              Close
            </button>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" reverseOrder={false} />
    </div>
  );
};

export default InvoicePopup;
